import { render } from "./ExpenseType.vue?vue&type=template&id=94664174"
import script from "./ExpenseType.vue?vue&type=script&lang=js"
export * from "./ExpenseType.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__